import { render } from "./TopicList.vue?vue&type=template&id=28ebf3a5&ts=true"
import script from "./TopicList.vue?vue&type=script&lang=ts"
export * from "./TopicList.vue?vue&type=script&lang=ts"

import "./TopicList.vue?vue&type=style&index=0&id=28ebf3a5&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__